import { render, staticRenderFns } from "./StudentTimetable.vue?vue&type=template&id=1f5b7c6c"
import script from "./StudentTimetable.vue?vue&type=script&lang=js"
export * from "./StudentTimetable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports